<template>
  <div class='advanced-filters-header'>
    <div class="organization-select" :class="[layout]" v-if='organizations.length > 1'>
      <advanced-organization-select
        :title="$t('dashboard.header.select.organization.outside').toString()"
        @applyOrganization='applyOrganizations'
      />
    </div>
    <div class="domain-select" :class="[layout, { 'single': organizations.length <= 1 }]" v-if='selectDomainEnabled'>
      <advanced-domain-select
        :title="$t('advanced.select.header.select.domain.cloud.account.outside').toString()"
        :items="domainOptions"
        @apply='applyDomains'
      />
    </div>
    <div class="add-domain" v-if='addDomainEnabled'>
      <v-btn class="add-domain__btn" color="primary" @click="showAddDomainPopup">
        {{ $t('configuration.add.domain') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import AdvancedOrganizationSelect from '@/components/common/AdvancedOrganizationSelect.vue';
import AdvancedDomainSelect from '@/components/common/AdvancedDomainSelect.vue';
import { mapGetters } from 'vuex';
import { LOAD_ALL_ORGANIZATIONS } from '@/store/organization/actionTypes';
import {SET_ORGANIZATION_FILTER} from '@/store/filters/actionTypes';

export default {
  name: 'AdvancedFiltersHeader',
  components: { AdvancedDomainSelect, AdvancedOrganizationSelect },
  async created() {
    await this.$store.dispatch(LOAD_ALL_ORGANIZATIONS);
    await this.setDefaultOrganization();
  },
  props: {
    addDomainEnabled: {
      default: false,
      type: Boolean,
    },
    selectDomainEnabled: {
      default: true,
      type: Boolean,
    },
    layout: {
      require: false,
      default: 'configuration',
      type: String,
    },
  },
  data() {
    return {
      showPopup: false,
    };
  },
  computed: {
    ...mapGetters([
      'organizationFilter',
      'organizations',
      'domains',
      'companyData',
      'configurationDomains',
      'domainsPerOrganization',
      'cloudAccountsPerOrganization',
    ]),
    domainOptions() {
      let items = [];
      if (this.organizationFilter) {
        this.organizationFilter.forEach(org => {
          items = items.concat([...(this.domainsPerOrganization.get(org) || [])].map(item => ({value: item, type: 'domain', organization: org })));
          items = items.concat([...(this.cloudAccountsPerOrganization.get(org) || [])].map(item => ({value: item, type: 'cloud', organization: org })));
        });
      } else {
        items = [...new Set([...this.domains])]; // DEFAULT COMPANY DOMAIN
      }
      return [...new Set(items)];
    },
  },
  methods: {
    async setDefaultOrganization() {
      if (!this.organizationFilter || this.organizationFilter.length === 0) {
        if (this.companyData?.name?.length > 0) { // IF WE HAVE DEFAULT ORGANIZATION
          await this.$store.dispatch(SET_ORGANIZATION_FILTER, Array.from(new Set([this.companyData.name])));
        } else {
          setTimeout(this.setDefaultOrganization, 300);
        }
      }
    },
    applyDomains() {
      this.$emit('applyDomains');
    },
    applyOrganizations() {
      this.$emit('applyOrganizations');
    },
    showAddDomainPopup() {
      this.$emit('showAddDomainPopup');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.advanced-filters-header {
  display: flex;
  flex-direction: row;
  align-items: center;

  .add-domain {
    display: flex;
    margin-left: $space-5;
    margin-bottom: -$space-4;
    margin-top: -5.3125rem; // -85px

    &__btn.v-btn.v-btn.v-btn {
      background-color: var(--brand-primary);
      font-size: $font-size-sm;
      color: #ffffff;
      font-family: $font-family-medium;
      text-transform: uppercase;
    }
  }

  .domain-select {
    margin-left: $space-8; // Space between organization and domain inputs

    &.dashboard {
      margin-left: $space-8;
    }
    &.single {
      margin-left: 0;
    }
  }

  .domain-select,
  .organization-select {
    width: 21.875rem; // 350px

    &.configuration {
      margin-top: -5.3125rem; // -85px
    }
    &.issues {
      margin-top: $space-2;
      margin-bottom: $space-10;
    }
    &.dashboard {
      margin-top: $space-1;
    }
    &.insights {
      margin-top: $space-2;
      margin-bottom: $space-4;
    }
    &.inventory {
      // Uses configuration layout
    }
    &.reports {
      // No specific styles
    }
    &.projects {
      margin-top: $space-2;
      margin-bottom: $space-10;
    }
    &.ctc {
      margin-top: $space-4;
    }
  }

  .organization-select {
    width: 17.8125rem; // 285px
  }
}
</style>
